import {useState} from "react";
import {KTSVG} from "../../../../../_metronic/helpers";
import {EventSubscriptionForm} from "./EventSubscriptionForm";
import {IHandleCloseProps} from "../../../simcard/models/Modal";

export interface ICreateEventSubscriptionProps {
    onFinish: () => void
}

/**
 * Создание подписки на событие
 */
export function CreateEventSubscription({onFinish}: ICreateEventSubscriptionProps) {
    const [show, setShow] = useState(false)

    const closeModal = ({isSubmitted}: IHandleCloseProps) => {
        setShow(false)
        isSubmitted && onFinish()
    }

    return (
        <div className="px-5 mt-5">
            <div>
                <span className="d-flex align-items-center text-gray-600 fs-6" style={{cursor: "pointer"}} onClick={() => setShow(true)}>
                    <KTSVG path='/media/icons/duotune/general/gen035.svg' className='svg-icon svg-icon-1 me-3 mx-3'/>
                    <span>Создать</span>
                </span>
            </div>
            <EventSubscriptionForm show={show} handleClose={closeModal}/>
        </div>
    )
}
